// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ft500[data-v-da893aaa]{font-weight:700}[data-v-da893aaa] .el-table thead.is-group th{background:#fafafa!important}.bg-white[data-v-da893aaa]{background-color:#fff!important}.cards[data-v-da893aaa]{background:#fff;padding:15px 10px 0 10px!important;padding-right:0!important;margin-bottom:15px}", ""]);
// Exports
module.exports = exports;
